import React, { useState, useRef, useEffect } from "react";
import FormControl from "react-bootstrap/FormControl";
import InputGroup from "react-bootstrap/InputGroup";
import Dropdown from "react-bootstrap/Dropdown";

const SearchDropdown = ({ label, options, selectedValue, onSelect }) => {
    const [searchValue, setSearchValue] = useState(selectedValue || "");
    const [isOpen, setIsOpen] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);
    const listRef = useRef(null);

    // Filter options based on search input
    const filteredOptions = searchValue
        ? options.filter((option) =>
              option.toLowerCase().includes(searchValue.toLowerCase())
          )
        : options;

    // Handle keyboard navigation & Enter selection
    const handleKeyDown = (e) => {
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setIsOpen(true);
            setHighlightedIndex((prev) =>
                prev < filteredOptions.length - 1 ? prev + 1 : 0
            );
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setIsOpen(true);
            setHighlightedIndex((prev) =>
                prev > 0 ? prev - 1 : filteredOptions.length - 1
            );
        } else if (e.key === "Enter") {
            e.preventDefault();
            if (highlightedIndex >= 0) {
                const selectedOption = filteredOptions[highlightedIndex];
                setSearchValue(selectedOption);
                setIsOpen(false);
                setHighlightedIndex(-1);
                onSelect(selectedOption);
                setTimeout(() => inputRef.current.blur(), 100);
            }
        } else if (e.key === "Escape") {
            setIsOpen(false);
        }
    };

    // Scroll to highlighted option in dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    

    

    return (
        <div ref={dropdownRef} className="search-dropdown" style={{ position: "relative", width: "50%" }}>
            <Dropdown show={isOpen} onToggle={(isOpen) => setIsOpen(isOpen)}>
                <Dropdown.Toggle
                    as={InputGroup}
                    onClick={(e) => {
                        setIsOpen(true);
                        setHighlightedIndex(-1);
                        e.stopPropagation();
                    }}
                    
                >
                    <FormControl
                        ref={inputRef}
                        placeholder={label || "Search"}
                        aria-label="Search Dropdown"
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            setIsOpen(true);
                            setHighlightedIndex(-1);
                        }}
                        value={searchValue}
                        onFocus={() => {
                            setIsOpen(true);
                            setHighlightedIndex(-1); 
                        }}
                        onKeyDown={handleKeyDown} 
                        
                        
                    />
                </Dropdown.Toggle>
                {isOpen && (
                    <Dropdown.Menu
                        ref={listRef}
                        style={{
                            maxHeight: "150px",
                            overflowY: "auto",
                            width: "100%",
                        }}
                    >
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((option, index) => (
                                <Dropdown.Item
                                    key={index}
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                        setSearchValue(option);
                                        setIsOpen(false);
                                        onSelect(option);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            setSearchValue(option);
                                            setIsOpen(false);
                                            onSelect(option);
                                            inputRef.current.blur();
                                        }
                                    }}
                                    active={highlightedIndex >= 0 && index === highlightedIndex}
                                    style={{
                                        backgroundColor: index === highlightedIndex ? "#007bff" : "white",
                                        color: index === highlightedIndex ? "white" : "black",
                                    }}
                                    
                                >
                                    {option}
                                </Dropdown.Item>
                            ))
                        ) : (
                            <Dropdown.Item disabled>No results found</Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                )}
            </Dropdown>
        </div>
    );
};

export default SearchDropdown;
